$(document).ready(function () {
    let $products = $(".product-preview");
    let $loadMoreButton = $("#load-more-button");

    let productsCount = 8;
    $products.addClass("hidden");
    
    showMore();


    $loadMoreButton.click(function() {
        productsCount += 8;
        showMore();
    });

    function showMore(){
        $products.slice(0, productsCount).removeClass("hidden");
        if(productsCount >= $products.length){
            $loadMoreButton.attr("style", "display: none !important");
        }
    }
});